export const PAYMENT_METHODS_URL = '/api/v1/user/payment'
export const PAYMENT_RULES_URL = '/api/v1/configuration/payment-rules'
